module.exports = __webpack_public_path__ + "img/bgPersonalCertificate.1f3e8e8e.png";